export enum EDodoDepositPaymentMethod {
  card = 'card',
  googlePay = 'google_pay',
  applePay = 'apple_pay',
  amazonPay = 'amazon_pay',
  weChatPay = 'we_chat_pay',
}
